import { render } from "./SOB.vue?vue&type=template&id=2ceaf078&scoped=true"
import script from "./SOB.vue?vue&type=script&lang=js"
export * from "./SOB.vue?vue&type=script&lang=js"

import "./SOB.vue?vue&type=style&index=0&id=2ceaf078&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ceaf078"],['__file',"src/views/pharmarcy/SOB.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ceaf078"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ceaf078', __exports__)) {
    api.reload('2ceaf078', __exports__)
  }
  
  module.hot.accept("./SOB.vue?vue&type=template&id=2ceaf078&scoped=true", () => {
    api.rerender('2ceaf078', render)
  })

}


export default __exports__